export default function NextArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path d="M1 0.5L7 7L1 13.5" stroke="black" />
    </svg>
  );
}
